import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { ProfileContext } from "../../reducers/profile";

export default ({ children, ...rest }) => {
  const {
    state: { is_auth },
  } = useContext(ProfileContext);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        is_auth ? (
          <Redirect
            to={{
              pathname: "/finalists",
              state: { from: location },
            }}
          />
        ) : (
          children
        )
      }
    />
  );
};
